import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { MdPlayCircleFilled, MdPauseCircleFilled } from 'react-icons/md';

import { play, pause } from "../../store/actions/audio";
import { setTracks } from "../../store/actions/tracks";
import { formatDuration } from '../../utils/formatDigits';
import getTrackInfo from "../../requests/trackInfo";
import Button from '../Form/Button';
import { Loading } from '../../components/Icons';
import styles from './Player.module.scss';
class Player extends React.Component {
  constructor(props) {
    super();
    this.state = {
      src: props.src,
      trackId: props.trackId,
      showTooltip: true
    };
  }
  componentDidMount() {
    if (!this.state.src && this.state.trackId) {
      if (!this.props.tracks[this.state.trackId]) {
        getTrackInfo(this.state.trackId)
          .then(response => {
            if(response.data && response.data.tracks && response.data.tracks.length){
              this.setState({
                src: response.data.tracks[0].oggPath
              })
              this.props.setTracks(response.data.tracks)
            }
          })
      } else {
        this.setState({ src: this.props.tracks[this.state.trackId].oggPath })
      }
    }
  }
  handlePlayPauseButton = e => {
    e.stopPropagation();
    if (this.state.src) {
      if (this.props.audio.playing) {
        this.props.pause();
        if (!this.isCurrentTrack()) {
          this.props.play(this.state.src);
        }
      } else {
        this.props.play(this.state.src)
      }
    } else {
      this.props[this.props.audio.playing ? 'pause' : 'play']();
    }
  }
  isCurrentTrack = () => this.props.audio.src === this.state.src || !this.state.src;
  render() {
    const { tracks, src, trackId, showTimer = false, audio, btnClassName, setTracks, play, pause, className, ...rest } = this.props;
    return (
      <div
        dir="ltr"
        className={classNames('d-flex align-items-center justify-content-center', className, styles.root)}
        {...rest}
      >
        {tracks && tracks[this.state.trackId] &&
          <img src={tracks[this.state.trackId].image+'/r/100x100'} alt={tracks[this.state.trackId].name} width="32" className={classNames('rounded', styles.cover)} />
        }
        <Button
          type="button"
          color="link"
          onClick={this.handlePlayPauseButton}
          className={classNames(styles.button, btnClassName, 'p-0 mr-1 ml-1')}
        >
          {(!audio.playing || !this.isCurrentTrack()) && <MdPlayCircleFilled />}
          {audio.playing && this.isCurrentTrack() && <MdPauseCircleFilled />}
          {audio.loading && this.isCurrentTrack() &&
            <Loading className={styles.loading} />
          }
          {!!window.audioPlayer.duration && audio.playing && !audio.loading && this.isCurrentTrack() && (
            <Loading
              className={styles.loading}
              progress={audio.time / window.audioPlayer.duration}
            />
          )}
        </Button>
        {
          !audio.loading && audio.playing && showTimer && this.isCurrentTrack() && (
            <small className={styles.time}>
              {formatDuration(Math.ceil(window.audioPlayer.duration - audio.time))}
            </small>
          )
        }
      </div>
    );
  }
}

Player.propTypes = {
  src: PropTypes.string,
  trackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  play: PropTypes.func,
  pause: PropTypes.func,
  className: PropTypes.string
};
Player.defaultProps = {
  src: null,
  trackId: null,
  play: () => { },
  pause: () => { },
  className: null
};


export default connect(
  state => (
    {
      audio: state.audio,
      tracks: state.tracks
    }
  ),
  dispatch => bindActionCreators({
    play,
    pause,
    setTracks
  }, dispatch)
)(Player)